import { all, fork } from "redux-saga/effects";
import subsSaga from "../../views/subscriber/saga";


export default function* rootSubsSaga() {
  // yield all([fork(fetchPaymentList())]);
  yield all([fork(subsSaga)]);

}